import { useQuery } from 'react-query';

import { FeaturedBanner } from '../../../types/FeaturedBanner';
import Api from '../../api/api';

export const getAllFeaturedBanners = async (): Promise<FeaturedBanner[]> => {
  const [response, bodyOrError] = await Api.get(`featured-banner`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetAllFeaturedBanners = () =>
  useQuery(['getAllFeaturedBanners'], getAllFeaturedBanners, {
    initialData: [],
  });
